import { render, staticRenderFns } from "./RelayControl.vue?vue&type=template&id=3ad4abea&scoped=true"
import script from "./RelayControl.vue?vue&type=script&lang=js"
export * from "./RelayControl.vue?vue&type=script&lang=js"
import style0 from "./RelayControl.vue?vue&type=style&index=0&id=3ad4abea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad4abea",
  null
  
)

export default component.exports